import { render } from "./Match.vue?vue&type=template&id=2118db31&scoped=true&ts=true"
import script from "./Match.vue?vue&type=script&setup=true&lang=ts"
export * from "./Match.vue?vue&type=script&setup=true&lang=ts"

import "./Match.vue?vue&type=style&index=0&id=2118db31&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2118db31"],['__file',"src/views/match/Match.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2118db31"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2118db31', __exports__)) {
    console.log('reload')
    api.reload('2118db31', __exports__)
  }
  
  module.hot.accept("./Match.vue?vue&type=template&id=2118db31&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('2118db31', render)
  })

}


export default __exports__